import { animationSliceActions } from '@/modules/animation/slice';
import { tableBetSliceActions } from '@/modules/betTable/slice';
import {
    getHostLiveDataByHostId,
    hostLiveSliceActions,
} from '@/modules/hostLive/slice';
import { AnyAction, Dispatch } from '@reduxjs/toolkit';
import { batch } from 'react-redux';
import { isPlayerSeated } from '../../../modules/bet/room/slice';
import { SupportedGameResult } from '../../../modules/host/models';
import { getHostById, hostsSliceActions } from '../../../modules/host/slice';
import { getMainUserState } from '../../../modules/main/selector';
import store from '../../../store/store';
import { updateRemainTime } from '../../../utils/commonFunc';
import { GameState } from '../../games/enums/GameState';
import { GameType as GameTypeEnum } from '../../games/enums/GameType';
import { CMDScStartBet, ICommand } from '../live';
import { AbstractHandler } from './AbstractHandler';
import { HostMessage } from '@/models/games/BaseHostMessage';
import { AnimationType } from '@/models/games/BaseAnimation';

export class CMDScStartBetHandler extends AbstractHandler {
    _command: CMDScStartBet;

    constructor(command: ICommand) {
        super();
        this._command = command as CMDScStartBet;
    }
    forceRun() {
        const state = store.getState();
        const hostLiveData = getHostLiveDataByHostId(
            state,
            this._command.HostID
        );
        if (hostLiveData.CurrentResult) {
            return hostLiveData.CurrentResult.GameID.toString();
        }
        return '';
    }
    override handle(dispatch: Dispatch<AnyAction>): void {
        const newResult = {} as SupportedGameResult;
        newResult.GameID = this._command.GameID;
        newResult.GameCount = this._command.GameCount;
        const state = store.getState();
        const { PlayerID } = getMainUserState(state);
        const host = getHostById(state, this._command.HostID);
        const hostLiveData = getHostLiveDataByHostId(
            state,
            this._command.HostID
        );
        hostLiveData.ShuffleTimer && clearTimeout(hostLiveData.ShuffleTimer);
        if (host) {
            batch(() => {
                console.log(`hook::socket::run::${host.HostId}`, this._command);
                const { GameType } = host;
                switch (GameType) {
                    case GameTypeEnum.CarnivalTreasure:
                        dispatch(
                            hostLiveSliceActions.startBet({
                                hostId: this._command.HostID,
                                result: newResult,
                                remainTime: updateRemainTime(
                                    this._command.RemainTime - 1
                                ),
                            })
                        );
                        dispatch(
                            hostsSliceActions.startBet({
                                hostId: this._command.HostID,
                                result: newResult,
                                remainTime: updateRemainTime(
                                    this._command.RemainTime - 1
                                ),
                            })
                        );
                        dispatch(
                            tableBetSliceActions.startBet({
                                hostId: this._command.HostID,
                                gameId: this._command.GameID,
                            })
                        );
                        //fast cutoff
                        setTimeout(
                            () => {
                                dispatch(
                                    hostLiveSliceActions.updateGameState({
                                        hostId: host.HostId,
                                        state: GameState.Started,
                                    })
                                );
                            },
                            (this._command.RemainTime - 2) * 1000
                        );
                        dispatch(animationSliceActions.reset(host.HostId));
                        dispatch(
                            animationSliceActions.save({
                                hostId: host.HostId,
                                last: {
                                    animationType: AnimationType.STOP,
                                    initialPayouts: [],
                                },
                            })
                        );
                        //reset host message
                        dispatch(
                            hostsSliceActions.updateHostMessageId({
                                hostId: host.HostId,
                                msgId: HostMessage.NoMessage,
                            })
                        );
                        break;
                    case GameTypeEnum.Blackjack:
                        if (
                            isPlayerSeated(
                                state,
                                this._command.HostID,
                                PlayerID
                            )
                        ) {
                            dispatch(
                                hostLiveSliceActions.startBet({
                                    hostId: this._command.HostID,
                                    result: newResult,
                                    remainTime: updateRemainTime(
                                        host.GameDelay
                                            ? host.GameDelay.kickNoBetPlayer /
                                                  1000
                                            : 0
                                    ),
                                    countDown: host.GameDelay
                                        ? host.GameDelay.kickNoBetPlayer
                                        : 0,
                                    pendingTime:
                                        this._command.RemainTime * 1000 -
                                        (host.GameDelay
                                            ? host.GameDelay.kickNoBetPlayer
                                            : 0),
                                    canLeave: true,
                                })
                            );
                            dispatch(
                                hostsSliceActions.startBet({
                                    hostId: this._command.HostID,
                                    result: newResult,
                                    remainTime: updateRemainTime(
                                        host.GameDelay
                                            ? host.GameDelay.kickNoBetPlayer /
                                                  1000
                                            : 0
                                    ),
                                    countDown: host.GameDelay
                                        ? host.GameDelay.kickNoBetPlayer
                                        : 0,
                                    pendingTime:
                                        this._command.RemainTime * 1000 -
                                        (host.GameDelay
                                            ? host.GameDelay.kickNoBetPlayer
                                            : 0),
                                    canLeave: true,
                                })
                            );
                        } else {
                            dispatch(
                                hostLiveSliceActions.startBet({
                                    hostId: this._command.HostID,
                                    result: newResult,
                                    remainTime: updateRemainTime(
                                        this._command.RemainTime
                                    ),
                                    countDown: this._command.RemainTime * 1000,
                                    canLeave: false,
                                })
                            );
                            dispatch(
                                hostsSliceActions.startBet({
                                    hostId: this._command.HostID,
                                    result: newResult,
                                    remainTime: updateRemainTime(
                                        this._command.RemainTime
                                    ),
                                    countDown: this._command.RemainTime * 1000,
                                    canLeave: false,
                                })
                            );
                        }
                        dispatch(
                            tableBetSliceActions.startBet({
                                hostId: this._command.HostID,
                                gameId: this._command.GameID,
                            })
                        );
                        break;
                    case GameTypeEnum.Blackjack2:
                        dispatch(
                            hostLiveSliceActions.startBet({
                                hostId: this._command.HostID,
                                result: newResult,
                                remainTime: updateRemainTime(
                                    this._command.RemainTime - 1
                                ),
                                countDown: this._command.RemainTime * 1000,
                            })
                        );
                        dispatch(
                            hostsSliceActions.startBet({
                                hostId: this._command.HostID,
                                result: newResult,
                                remainTime: updateRemainTime(
                                    this._command.RemainTime - 1
                                ),
                                countDown: this._command.RemainTime * 1000,
                            })
                        );
                        dispatch(
                            tableBetSliceActions.startBet({
                                hostId: this._command.HostID,
                                gameId: this._command.GameID,
                            })
                        );
                        // //fast cutoff
                        // setTimeout(
                        //     () => {
                        //         dispatch(
                        //             hostLiveSliceActions.updateGameState({
                        //                 hostId: host.HostId,
                        //                 state: GameState.Started,
                        //             })
                        //         );
                        //     },
                        //     (this._command.RemainTime - 2) * 1000
                        // );
                        break;
                    case GameTypeEnum.Baccarat:
                    case GameTypeEnum.PokDeng:
                    case GameTypeEnum.SeDie:
                    case GameTypeEnum.SicBo:
                    case GameTypeEnum.ThaiHiLo:
                    case GameTypeEnum.FishPrawnCrab:
                    case GameTypeEnum.TeenPatti2020:
                    case GameTypeEnum.AndarBahar:
                    case GameTypeEnum.Roulette:
                    case GameTypeEnum.Dragon:
                    default:
                        dispatch(
                            hostLiveSliceActions.startBet({
                                hostId: this._command.HostID,
                                result: newResult,
                                remainTime: updateRemainTime(
                                    this._command.RemainTime - 1
                                ),
                            })
                        );
                        dispatch(
                            hostsSliceActions.startBet({
                                hostId: this._command.HostID,
                                result: newResult,
                                remainTime: updateRemainTime(
                                    this._command.RemainTime - 1
                                ),
                            })
                        );
                        dispatch(
                            tableBetSliceActions.startBet({
                                hostId: this._command.HostID,
                                gameId: this._command.GameID,
                            })
                        );
                        //fast cutoff
                        setTimeout(
                            () => {
                                dispatch(
                                    hostLiveSliceActions.updateGameState({
                                        hostId: host.HostId,
                                        state: GameState.Started,
                                    })
                                );
                            },
                            (this._command.RemainTime - 2) * 1000
                        );
                        break;
                }
            });
        } else {
            console.warn(
                'hook::socket::warning::cannot::find::host',
                this._command.GameID
            );
        }
    }
}
